import { useState } from "react";
import { Box, Button, Center, Image, Paper, Stack, Text } from "@mantine/core";
import { IconArrowRight } from "@tabler/icons-react";
import EcosystemCorridorHeadDetailsModal from "@/pages/ecosystem-heads/components/EcosystemCorridorHeadDetailsModal";

const CARD_BORDER = "#BFDBFE";
const PROMO_LOGO_HEIGHT = 38;

type EcosystemCorridorPromoCardProps = {
  fixedWidth?: number;
  variant?: "carousel" | "explore";
};

export default function EcosystemCorridorPromoCard({
  fixedWidth,
  variant = "carousel",
}: EcosystemCorridorPromoCardProps) {
  const isCarousel = variant === "carousel";
  const [detailsOpen, setDetailsOpen] = useState(false);

  return (
    <>
    <Paper
      radius="lg"
      shadow="none"
      h="100%"
      mih={188}
      style={{
        border: `1px solid ${CARD_BORDER}`,
        overflow: "hidden",
        background: "linear-gradient(145deg, #04305c 0%, #0b4a8c 55%, #1565c0 100%)",
        ...(fixedWidth ? { flex: "0 0 auto", width: fixedWidth, maxWidth: "85vw" } : undefined),
      }}
    >
      <Stack gap="md" h="100%" p="lg" justify="space-between">
        <Stack
          gap="sm"
          align={isCarousel ? "center" : "flex-start"}
          justify="center"
          style={{ flex: 1 }}
        >
          <Center w={isCarousel ? "100%" : undefined}>
            <Box
              px="sm"
              py={6}
              style={{
                borderRadius: 12,
                backgroundColor: "#FFFFFF",
                border: "1px solid rgba(255, 255, 255, 0.22)",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                lineHeight: 0,
              }}
            >
              <Image src="/gtLogo.svg" alt="GTsetu" h={PROMO_LOGO_HEIGHT} w="auto" />
            </Box>
          </Center>

          <Text
            fw={700}
            size="sm"
            tt="uppercase"
            ta={isCarousel ? "center" : "left"}
            c="#FFFFFF"
            lh={1.35}
          >
            Be an Ecosystem Corridor Head
          </Text>
          <Text
            size="xs"
            ta={isCarousel ? "center" : "left"}
            c="rgba(255, 255, 255, 0.82)"
            lh={1.45}
            lineClamp={3}
          >
            Lead a cross-border corridor, connect verified businesses, and grow trade in your sector.
          </Text>
        </Stack>

        <Button
          size="sm"
          fullWidth
          rightSection={<IconArrowRight size={14} />}
          onClick={() => setDetailsOpen(true)}
          styles={{
            root: {
              minHeight: 38,
              fontWeight: 600,
              backgroundColor: "#FFFFFF",
              color: "#04305c",
              "&:hover": { backgroundColor: "#EFF6FF" },
            },
          }}
        >
          See Details
        </Button>
      </Stack>
    </Paper>

    <EcosystemCorridorHeadDetailsModal opened={detailsOpen} onClose={() => setDetailsOpen(false)} />
    </>
  );
}
